import React, { Component, State } from 'react';
import { withAuth } from '@okta/okta-react';
import { Col, FormGroup, Row } from 'reactstrap';
import CreatableSelect from 'react-select/creatable';
import Api from '../../Api';
import Help from '../../HtmlHelpers';
export default withAuth(class WmCreatableSelect extends Component {
  constructor(props) {
    super(props);
    this.getDropdown = () => /*#__PURE__*/React.createElement(Col, {
      md: this.props.fieldColumns
    }, /*#__PURE__*/React.createElement(CreatableSelect, {
      isClearable: true,
      id: this.props.name,
      name: this.props.name,
      value: this.props.selected,
      options: this.state.data,
      required: true,
      onChange: this.handleChange,
      className: "text-left"
    }), /*#__PURE__*/React.createElement("div", {
      className: "invalid-feedback"
    }));
    this.handleChange = (newValue, actionMeta) => {
      if (actionMeta.action === 'create_option') {
        this.setState(prevState => {
          const newData = Object.assign([], prevState.data);
          newData.push(newValue);
          return {
            data: newData
          };
        });
      }
      const value = {
        target: {
          name: this.props.name,
          value: newValue
        }
      };
      if (this.props.additionalInfo !== undefined) {
        this.props.onChange(value, this.props.additionalInfo);
      } else {
        this.props.onChange(value);
      }
    };
    this.state = {
      data: [{
        label: 'loading',
        value: 'loading'
      }]
    };
  }
  async componentDidMount() {
    const props = this.props;
    Api.crudList(props.auth, props.apiLink, props.apiParams).then(response => {
      this.setState({
        data: Help.buildOptions(response, props.labelField, props.valueField)
      });
    });
  }
  render() {
    return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Row, {
      className: "align-items-center"
    }, Help.getWmLabel(this.props), this.getDropdown()));
  }
});